import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setIncompleteVisitsCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getIncompleteVisitsCount() {
            return HTTP.get('/kenya/subjects_incomplete_visit/get_count');
        }
    },
}